import {
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography
} from '@mui/material';
import React, { useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import ArticleIcon from '@mui/icons-material/Article';
import { useTranslation } from 'react-i18next';
import { InfoOutlined } from '@mui/icons-material';

interface TableToolTipProps {
	headers: string[] | undefined;
	rows: string[][] | undefined;
}

const TableTooltip = ({ headers, rows }: TableToolTipProps) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const handleClickOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	const handleDownload = () => {
		if (headers) {
			const csvContent = headers.join(',');
			const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
			const link = document.createElement('a');
			const url = URL.createObjectURL(blob);
			link.setAttribute('href', url);
			link.setAttribute('download', 'PearsanaBulkUploadStudentsTemplate.csv');
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	};

	const tableContent = (
		<div style={{ overflowX: 'auto' }}>
			<Table size="small">
				<TableHead>
					<TableRow>
						{headers?.map((header: string, index: number) => (
							<TableCell key={index}>{header}</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{rows?.map((row: string[], rowIndex: number) => (
						<TableRow key={rowIndex}>
							{row.map((cell: string, cellIndex: number) => (
								<TableCell key={cellIndex}>{cell}</TableCell>
							))}
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);

	return (
		<>
			<div
				style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}
			>
				<div>
					<Typography variant="caption" sx={{ pl: 1 }}>
						{t('pages.organisation.dashboard.bulkUpload.exampleFileFormat')}
					</Typography>
					<IconButton onClick={handleClickOpen}>
						<ArticleIcon />
					</IconButton>
				</div>

				<div>
					<Typography variant="caption" sx={{ pl: 1 }}>
						{t('pages.organisation.dashboard.bulkUpload.downloadTemplate')}
					</Typography>
					<IconButton onClick={handleDownload}>
						<DownloadIcon />
					</IconButton>
				</div>
			</div>

			<Stack
				direction="row"
				alignItems="center"
				spacing={0.25}
				sx={{
					mt: 1,
					px: 1,
					opacity: 0.85,
					userSelect: 'none'
				}}
			>
				<InfoOutlined
					fontSize="inherit"
					sx={{
						fontSize: '0.9rem',
						mr: 0.5
					}}
				/>

				<Typography
					variant="caption"
					sx={{
						lineHeight: 1.6,
						flexGrow: 1
					}}
				>
					Only the <strong>Email</strong> column is required. All other columns are optional.
				</Typography>
			</Stack>

			<Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
				<DialogTitle>{t('pages.organisation.dashboard.bulkUpload.expectedFileLayout')}</DialogTitle>
				<DialogContent dividers sx={{ overflow: 'auto' }}>
					{tableContent}
				</DialogContent>
				<Button onClick={handleClose}>Close</Button>
			</Dialog>
		</>
	);
};

export default TableTooltip;
